import { FC } from 'react';
import useTimeFormatters from '../../shared/hooks/useTimeFormatters';
import useElapsedTime from '../../shared/hooks/useElapsedTime';
import ClockDisplay from './ClockDisplay';

interface IProps {
    timeStart: number | null;
    colorFn(elapsedTime: number): string;
    fullnessFn?(elapsedTime: number): number;
}

const ElapsedTimeClockDisplay: FC<IProps> = ({ timeStart, colorFn, fullnessFn }) => {
    const { formatTimeSpan } = useTimeFormatters();
    const elapsedTime = useElapsedTime(timeStart);
    const elapsedTimeStr = formatTimeSpan(elapsedTime);

    return <ClockDisplay text={elapsedTimeStr} color={colorFn(elapsedTime)} fullness={fullnessFn?.(elapsedTime)} />;
};

export default ElapsedTimeClockDisplay;